import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Lock, Unlock } from "lucide-react";
import { Button, Modal } from "../../../components";
import { PLATFORM_COMPANY_USERS_URL, PLATFORM_BLOCK_USER_URL } from "../../../features/UrlHelper";

/**
 * Pouzivatelia prevadzky (bez zakaznikov) s moznostou zablokovat.
 * Blokovanie = users.x__packed, ktory login uz dnes respektuje -- zablokovany
 * sa neprihlasi. Zmazani pouzivatelia sa tu zobrazuju tiez ako zablokovani.
 */
const ROLE_LABEL = { ADMIN: "Admin", MANAGER: "Dispečer", DRIVER: "Vodič", SUPERADMIN: "Superadmin" };

function CompanyUsersModal({ company, onClose }) {
  const [users, setUsers] = useState([]);
  const [chyba, setChyba] = useState("");
  const [pracuje, setPracuje] = useState(null);

  const nacitaj = useCallback(async () => {
    try {
      const { data } = await axios.get(PLATFORM_COMPANY_USERS_URL(company.id));
      setUsers(Array.isArray(data) ? data : []);
    } catch (err) {
      setChyba(err?.response?.data?.message || "Používateľov sa nepodarilo načítať.");
    }
  }, [company.id]);

  useEffect(() => {
    nacitaj();
  }, [nacitaj]);

  const prepni = async (user) => {
    setPracuje(user.id);
    setChyba("");
    try {
      await axios.post(PLATFORM_BLOCK_USER_URL(user.id), { blocked: !user.blocked });
      await nacitaj();
    } catch (err) {
      setChyba(err?.response?.data?.message || "Zmena zlyhala.");
    } finally {
      setPracuje(null);
    }
  };

  return (
    <Modal isOpen onClose={onClose} title={`Používatelia – ${company.name}`}>
      <div className="admin__form">
        {users.length === 0 ? (
          <p>Prevádzka nemá žiadnych používateľov.</p>
        ) : (
          <ul className="platform__list">
            {users.map((u) => (
              <li key={u.id} className={`platform__list-item${u.blocked ? " platform__list-item--muted" : ""}`}>
                <span>
                  <strong>{u.username}</strong> · {ROLE_LABEL[u.role] || u.role}
                  {[u.name, u.surname].filter(Boolean).length > 0 && ` · ${[u.name, u.surname].filter(Boolean).join(" ")}`}
                  {u.blocked && " · zablokovaný"}
                  {u.must_change_password && !u.blocked && " · čaká na zmenu hesla"}
                </span>
                <button
                  className={`admin__icon-btn${u.blocked ? "" : " admin__icon-btn--danger"}`}
                  title={u.blocked ? "Odblokovať" : "Zablokovať"}
                  disabled={pracuje === u.id}
                  onClick={() => prepni(u)}
                >
                  {u.blocked ? <Unlock size={16} /> : <Lock size={16} />}
                </button>
              </li>
            ))}
          </ul>
        )}

        {chyba && <p className="platform__error" role="alert">{chyba}</p>}

        <div className="admin__form-actions">
          <Button variant="ghost" onClick={onClose}>
            Zavrieť
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default CompanyUsersModal;
